import {gql} from '@apollo/client';

import {getRegistrySupportedOligoAwareTypesGraphQL} from 'constants/RegistryConstants';
import {OligoAwareFolderItemType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {BenchlingQueryResult, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

import {
  GetTagSchemaSummariesListing,
  GetTagSchemaSummariesListingVariables,
} from './__generated/GetTagSchemaSummariesListing';

export const TAG_SCHEMA_SUMMARIES_QUERY = gql`
  query GetTagSchemaSummariesListing(
    $searchInput: TagSchemaListingSearchInput
    $limitOffsetInput: LimitOffsetInput
  ) @skipAudit @engComponent(name: SCHEMAS) {
    tagSchemasListing(searchInput: $searchInput, limitOffsetInput: $limitOffsetInput) {
      tagSchemas {
        ...TagSchemaSummaryGraphQL
      }
      total
    }
  }

  ${getFragmentWrapper('TagSchemaSummary').fragment}
`;

export interface UseTagSchemaSummariesListingQueryArgs {
  registryId?: string | null;
  oligoAwareFolderItemTypes?: Array<OligoAwareFolderItemType> | null;
}

export default function useTagSchemaSummariesListingQuery({
  registryId,
  oligoAwareFolderItemTypes,
}: UseTagSchemaSummariesListingQueryArgs = {}): BenchlingQueryResult<GetTagSchemaSummariesListing> {
  return useBenchlingQuery<GetTagSchemaSummariesListing, GetTagSchemaSummariesListingVariables>(
    TAG_SCHEMA_SUMMARIES_QUERY,
    {
      variables: {
        searchInput: {
          registryId: registryId ?? null,
          oligoAwareFolderItemTypes:
            oligoAwareFolderItemTypes ?? getRegistrySupportedOligoAwareTypesGraphQL(),
        },
      },
    }
  );
}
